import { AuthService, type CheckPhoneNumberBodyDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  requestBody: CheckPhoneNumberBodyDto;
};

export const checkPhoneNumber = ({ call, requestBody }: TParams) =>
  call(() => AuthService.checkPhoneNumber({ requestBody }));
